import React from "react";
import "./App.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/HomePage.js";
import DigitalProgram from "./pages/DigitalProgram/DigitalProgramPage.js";
import Constellation from "./pages/Constellation/ConstellationPage.js";
import Enroll from "./pages/Enroll/EnrollPage.js";
import EnrollPagePackage from "./pages/Enroll/EnrollPagePackage.js";
import Confirmation from "./pages/Enroll/ConfirmationPage.js";
import ConfirmationPagePackage from "./pages/Enroll/ConfirmationPagePackage.js";
import useDatadog from "react-datadog";

export default function App() {
	useDatadog({
		clientToken: "pub40dd32a6fc77cae302baea1a6b229d8c",
		applicationId: "187a50dd-e25e-412e-b5cf-8496f6ded1fd",
		// `site` refers to the Datadog site parameter of your organization
		// see https://docs.datadoghq.com/getting_started/site/
		site: "datadoghq.com",
		service: "bmw-regional-digital-prd",
		env: "prod",
		// Specify a version number to identify the deployed version of your application in Datadog
		// version: '1.0.0',
		sessionSampleRate: 100,
		sessionReplaySampleRate: 100,
		trackUserInteractions: true,
		trackResources: true,
		trackLongTasks: true,
		defaultPrivacyLevel: "allow",
	});

	return (
		<div className="App">
			<Router>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/digital-program" element={<DigitalProgram />} />
					<Route path="/digital-program/constellation" element={<Constellation />} />
					<Route path="/enroll" element={<Enroll />} />
					<Route path="/enroll/package" element={<EnrollPagePackage />} />
					<Route path="/confirmation" element={<Confirmation />} />
					<Route path="/confirmation/package" element={<ConfirmationPagePackage />} />
				</Routes>
			</Router>
		</div>
	);
}
